<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="400" [baseZIndex]="10000"
              header="Buscador de Códigos Eppo" (onShow)="showDialogMaximized(dialDetail)" #dialDetail>

        <div class="animated fadeIn">

            <div class="row">
                <div class="col-md-12">
                    
                    <div class="card card-accent-success animated fadeIn">

                        <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Filtros
                                <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">

                            <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                            <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                                <div class="row margin-top8-popup">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="inpCodigo">Código Eppo</label>
                                        <div class="input-group">
                                            <input formControlName="CodigoEppo" name="CodigoEppo" title="" class="form-control" id="inpCodigo" type="text" value="">
                                        </div>
                                    </div>
                                </div>

                                <div class="row margin-top8-popup">
                                    <div class="col-md-12">
                                        <div class="form-group-0 float-right">

                                            <div class="btn-group">
                                                <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Buscar Código EPPO" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                            </div>

                                            <div class="btn-group">
                                                <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--GRID DATOS-->
            <div *ngIf="searchingButton" class="row">
                <div class="col-md-12">
                    <div class="label-msg-info m-1">
                        <i class="fa fa-info-circle fa-lg"></i> Haga doble click para seleccionar un Código Eppo
                    </div>
                    <div class="card card-accent-success">
                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Listado de Códigos Eppo
                        </div>

                        <div class="card-body">

                            <p-table #tableSearch autoLayout="true" [value]="resultCodigoEppo?.ResultList" [columns]="cols"
                                     selectionMode="single" [(selection)]="selectedCodigoEppo" dataKey="Id"
                                     [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                     [rows]="resultCodigoEppo?.PageSize" [totalRecords]="resultCodigoEppo?.TotalCount" [loading]="loading"
                                     styleClass="table table-responsive-sm  table-sm">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">

                                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (dblclick)="onRowDblClick($event, rowData)">
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            {{rowData[col.field]}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                            <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <p-footer>
            <button pButton (click)="acceptDialog()" [disabled]="noAccepted()" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>

    </p-dialog>
</form>
